import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { getDossierHistoricalsFleet, getDossierHistoricalsFleetSuccess } from '../../../../actions/management/management'
import DossierHistoricalsFleetComponent from '../../../../components/management/fleets/historicals/DossierHistoricalsFleetComponent'

export function mapStateToProps (state) {
  return {
    dossierHistoricalFleetDetails: state.management.dossierHistoricalFleetDetails
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      getDossierHistoricalsFleet,
      getDossierHistoricalsFleetSuccess
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(DossierHistoricalsFleetComponent))
